import { doDelete, doGet, doPost, doPut } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import type { CustomAnalyticsIntegration } from './types';

export const getCustomIntegration = (accountId: string, projectId: string) => {
  return doGet<CustomAnalyticsIntegration>(
    `accounts/${accountId}/projects/${projectId}/analytics/custom-integrations`,
    LOGGER_TYPE.ANALYTICS,
  );
};

export const createCustomIntegration = ({
  accountId,
  projectId,
}: {
  accountId: string;
  projectId: string;
}) => {
  return doPost<CustomAnalyticsIntegration>(
    `accounts/${accountId}/projects/${projectId}/analytics/custom-integrations`,
    LOGGER_TYPE.ANALYTICS,
  );
};

export const deleteCustomIntegration = ({
  accountId,
  projectId,
}: {
  accountId: string;
  projectId: string;
}) => {
  return doDelete<CustomAnalyticsIntegration>(
    `accounts/${accountId}/projects/${projectId}/analytics/custom-integrations`,
    LOGGER_TYPE.ANALYTICS,
  );
};

export const updateCustomIntegration = ({
  accountId,
  projectId,
  integrationId,
}: {
  accountId: string;
  projectId: string;
  integrationId: string;
}) => {
  return doPut<CustomAnalyticsIntegration>(
    `accounts/${accountId}/projects/${projectId}/analytics/custom-integrations`,
    LOGGER_TYPE.ANALYTICS,
    { integration_id: integrationId },
  );
};

export const updateCustomIntegrationConfig = ({
  accountId,
  projectId,
  integrationId,
  filterByProject,
}: {
  accountId: string;
  projectId: string;
  integrationId: string;
  filterByProject?: boolean;
}) => {
  return doPut<CustomAnalyticsIntegration>(
    `accounts/${accountId}/projects/${projectId}/analytics/custom-integrations/${integrationId}`,
    LOGGER_TYPE.ANALYTICS,
    { filter_by_project: filterByProject },
  );
};
